import { render, staticRenderFns } from "./SectionApvaInfo.vue?vue&type=template&id=66fd25bb&"
import script from "./SectionApvaInfo.vue?vue&type=script&lang=js&"
export * from "./SectionApvaInfo.vue?vue&type=script&lang=js&"
import style0 from "./SectionApvaInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports